/**
 * Hybrid Cup configurator swatches on Gumlet.
 * Full URL pattern:
 *   https://vinc.gumlet.io/gallery/hybrid-cup/cup/<slug>.jpg
 *   https://vinc.gumlet.io/gallery/hybrid-cup/sleeve/<slug>.jpg
 * Slugs must match filenames delivered to `gallery/hybrid-cup/cup/` and `.../sleeve/`.
 */

const GUMLET_BASE = 'https://vinc.gumlet.io/gallery/hybrid-cup'

function normalize(desc: string | null | undefined): string {
  return (desc ?? '').trim().toLowerCase()
}

const CUP_DESC_TO_SLUG: Record<string, string> = {
  'stainless steel': 'stainless-steel',
  'stainless steel (set of 3 cups)': 'stainless-steel-set-of-3-cups',
  aluminium: 'aluminium',
  'aluminium (set of 3 cups)': 'aluminium-set-of-3-cups',
}

const SLEEVE_DESC_TO_SLUG: Record<string, string> = {
  'black (leather)': 'black-leather',
  'brown (leather)': 'brown-leather',
  bumblebee: 'bumblebee',
  chocolate: 'chocolate',
  'classic green': 'classic-green',
  clementine: 'clementine',
  denim: 'denim',
  erdnase: 'erdnase',
  fuscia: 'fuscia',
  'green lemon': 'green-lemon',
  kraken: 'kraken',
  larimar: 'larimar',
  levitate: 'levitate',
  lobster: 'lobster',
  'midnight blue': 'midnight-blue',
  rose: 'rose',
}

const gumletResize = '?w=280&dpr=2'

/** Step 3 promo tile — same path as cup swatches: `cup/solid-cup.jpg`. */
const gumletPromoResize = '?w=520&dpr=2'

export function hybridCupSolidCupPromoImageUrl(): string {
  return `${GUMLET_BASE}/cup/solid-cup.jpg${gumletPromoResize}`
}

export function hybridCupCupSwatchUrl(
  description: string | null | undefined
): string | null {
  const slug = CUP_DESC_TO_SLUG[normalize(description)]
  if (!slug) return null
  return `${GUMLET_BASE}/cup/${slug}.jpg${gumletResize}`
}

export function hybridCupSleeveSwatchUrl(
  description: string | null | undefined
): string | null {
  const slug = SLEEVE_DESC_TO_SLUG[normalize(description)]
  if (!slug) return null
  return `${GUMLET_BASE}/sleeve/${slug}.jpg${gumletResize}`
}
